(() => {
  'use strict';
  if (window.TDHalloweenGift || !window.TDHalloweenGiftConfig) return;
  const config = window.TDHalloweenGiftConfig;
  const nativeFetch = window.fetch.bind(window);
  const base = window.Shopify?.routes?.root || '/';
  const storageKey = 'td_halloween_2026_email';
  const publicEnd = Date.parse(config.publicEndsAt);
  const emailEnd = Date.parse(config.emailEndsAt);
  const startsAt = Date.parse(config.startsAt || '2026-10-31T03:00:00Z');
  const threshold = Number(config.threshold);
  const variantId = Number(config.variantId);
  const labels = config.labels || {};
  let clock = Number(config.serverNow) || Date.now();
  let clockAnchor = performance.now();
  let emailAccess = false;
  let queue = Promise.resolve();
  let state = { busy: false, blocked: false, eligible: false, gift: false, error: '', expiresAt: publicEnd };
  let expiryTimer;
  let inert = false;
  let renderObserver;
  let viewDirty = false;
  let sectionRefresh = 0;
  const bypass = new WeakSet();
  const now = () => clock + performance.now() - clockAnchor;
  const isGift = item => Number(item.variant_id || item.id) === variantId && String(item.properties?._td_halloween_gift) === '2026';
  const gifts = cart => cart.items.filter(isGift);
  const amount = cart => Number(cart.total_price || 0) - gifts(cart).reduce((sum, item) => sum + Number(item.final_line_price || 0), 0);
  const expiry = () => emailAccess ? emailEnd : publicEnd;
  const active = () => now() >= startsAt && now() < expiry();
  const qualifies = cart => active() && (!cart.currency || cart.currency === 'CLP') && amount(cart) > threshold;
  const copy = key => labels[key] || ({ gift: 'REGALO HALLOWEEN', checking: 'Comprobando tu regalo de Halloween…', unavailable: 'No pudimos confirmar tu regalo de Halloween. Actualiza el carrito antes de pagar.', error: 'No pudimos verificar tu carrito. Actualízalo antes de continuar.' })[key];
  const failure = message => Object.assign(new Error(message), { halloweenGift: true });

  function announce(message = '') {
    document.querySelectorAll('[data-td-halloween-status]').forEach(element => {
      if (element.textContent !== message) element.textContent = message;
      element.hidden = !message;
    });
    document.documentElement.toggleAttribute('data-td-halloween-checking', state.busy);
    document.documentElement.toggleAttribute('data-td-halloween-blocked', state.blocked);
    document.documentElement.classList.toggle('td-halloween-gift-active', active());
    document.querySelectorAll('[data-td-halloween-banner]').forEach(element => { element.hidden = !active(); });
    document.querySelectorAll('[data-td-halloween-retry]').forEach(element => { element.hidden = !state.blocked; });
    document.querySelectorAll('[data-td-halloween-deadline]').forEach(element => {
      const deadline = emailAccess ? labels.emailDeadline || 'Hasta el domingo 1 de noviembre, 23:59.' : labels.publicDeadline || 'Solo hoy, 31 de octubre, hasta las 23:59.';
      if (element.textContent !== deadline) element.textContent = deadline;
    });
    document.dispatchEvent(new CustomEvent('td:halloween-state', { detail: { ...state, emailAccess, expiresAt: expiry() } }));
  }

  function rememberEmail() {
    try {
      const saved = JSON.parse(localStorage.getItem(storageKey) || 'null');
      emailAccess = saved?.expiresAt === emailEnd && saved?.code === config.emailCode && now() < emailEnd;
      if (!emailAccess) localStorage.removeItem(storageKey);
    } catch { emailAccess = false; }
    const entry = new URLSearchParams(window.location.search).get(config.emailParam || 'td_halloween');
    if (entry && entry === config.emailCode && now() < emailEnd && now() >= startsAt) {
      emailAccess = true;
      try { localStorage.setItem(storageKey, JSON.stringify({ code: config.emailCode, expiresAt: emailEnd })); } catch { }
    }
    state.expiresAt = expiry();
  }

  async function json(path, body) {
    const response = await nativeFetch(path, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json', ...(body ? { 'Content-Type': 'application/json' } : {}) }, ...(body ? { method: 'POST', body: JSON.stringify(body) } : {}), signal: AbortSignal.timeout(20000) });
    const date = Date.parse(response.headers.get('date') || '');
    if (Number.isFinite(date)) { clock = date; clockAnchor = performance.now(); }
    const data = await response.json();
    if (!response.ok || data.status) throw failure(data.description || data.message || copy('error'));
    return data;
  }

  const read = () => json(base + 'cart.js');

  function retire() {
    inert = true;
    clearTimeout(expiryTimer);
    renderObserver?.disconnect();
    if (window.fetch === interceptedFetch) window.fetch = nativeFetch;
  }

  async function removeGiftLines(cart) {
    const lines = gifts(cart);
    if (!lines.length) return cart;
    let failed;
    try { await json(base + 'cart/update.js', { updates: Object.fromEntries(lines.map(item => [item.key, 0])) }); } catch (error) { failed = error; }
    const confirmed = await read();
    if (gifts(confirmed).length) throw failed || failure(copy('error'));
    return confirmed;
  }

  async function applyEmailCode(cart) {
    if (!emailAccess || !active() || !config.emailCode) return cart;
    const codeStart = Date.parse(config.emailCodeStartsAt || config.startsAt || '2026-10-31T03:00:00Z');
    if (now() < codeStart) return cart;
    const existing = (cart.discount_codes || []).map(item => item.code).filter(Boolean);
    if (existing.some(code => code.toUpperCase() === config.emailCode.toUpperCase())) return cart;
    await json(base + 'cart/update.js', { discount: [...existing, config.emailCode].join(',') });
    return read();
  }

  async function check() {
    let cart = await read();
    let changed = false;
    if (!qualifies(cart)) {
      changed = gifts(cart).length > 0;
      cart = await removeGiftLines(cart);
      state.eligible = false;
      state.gift = false;
      if (now() >= emailEnd) retire();
      return { cart, changed };
    }
    state.eligible = true;
    const beforeCodes = JSON.stringify(cart.discount_codes || []);
    cart = await applyEmailCode(cart);
    changed = JSON.stringify(cart.discount_codes || []) !== beforeCodes;
    let lines = gifts(cart);
    if (lines.length > 1 || (lines.length === 1 && Number(lines[0].quantity) !== 1)) {
      cart = await removeGiftLines(cart);
      lines = [];
      changed = true;
    }
    if (!lines.length) {
      let problem;
      try { await json(base + 'cart/add.js', { items: [{ id: variantId, quantity: 1, properties: { _td_halloween_gift: '2026' } }] }); } catch (error) { problem = error; }
      cart = await read();
      changed = true;
      lines = gifts(cart);
      if (problem && !lines.length) throw failure(copy('unavailable'));
    }
    if (!qualifies(cart)) {
      cart = await removeGiftLines(cart);
      state.eligible = false;
      state.gift = false;
      return { cart, changed: true };
    }
    const verified = lines.length === 1 && Number(lines[0].quantity) === 1 && Number(lines[0].final_line_price) === 0;
    if (!verified) {
      cart = await removeGiftLines(cart);
      state.gift = false;
      throw Object.assign(failure(copy('unavailable')), { cart, changed: true });
    }
    state.gift = true;
    return { cart, changed };
  }

  async function sections(ids) {
    const url = new URL(window.location.href);
    url.searchParams.delete('sections');
    if (/^\d+$/.test(String(config.themeId || ''))) url.searchParams.set('preview_theme_id', String(config.themeId));
    const endpoint = new URL(base + 'cart/update.js', window.location.origin);
    if (/^\d+$/.test(String(config.themeId || ''))) endpoint.searchParams.set('preview_theme_id', String(config.themeId));
    try {
      const data = await json(endpoint.pathname + endpoint.search, { updates: {}, sections: ids, sections_url: url.pathname + url.search });
      const missingIds = ids.filter(id => typeof data.sections?.[id] !== 'string' || !data.sections[id].trim());
      if (missingIds.length) {
        try { return await pageSections(ids, url); }
        catch (error) {
          console.warn('[THE DOGS Halloween] Section refresh unavailable ' + JSON.stringify({ requestedIds: ids, returnedIds: Object.keys(data.sections || {}), missingIds, themeId: config.themeId }));
          throw error;
        }
      }
      return data.sections;
    } catch (error) {
      viewDirty = true;
      throw error;
    }
  }

  async function pageSections(ids, url) {
    url.searchParams.set('_td_halloween_refresh', String(Math.floor(now())) + '-' + (++sectionRefresh));
    const response = await nativeFetch(url.pathname + url.search, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'text/html' }, signal: AbortSignal.timeout(20000) });
    if (!response.ok) throw failure(copy('error'));
    const page = new DOMParser().parseFromString(await response.text(), 'text/html');
    const result = {};
    for (const id of ids) {
      const wrapper = page.getElementById('shopify-section-' + id);
      if (wrapper) { result[id] = wrapper.outerHTML; continue; }
      if (id === 'cart-drawer') {
        const drawer = page.getElementById('CartDrawer');
        if (drawer) result[id] = '<div class="shopify-section">' + drawer.outerHTML + '</div>';
      } else if (id === 'cart-icon-bubble' || id === 'cart-live-region-text') {
        const source = page.getElementById(id);
        if (source) result[id] = '<div class="shopify-section">' + source.innerHTML + '</div>';
      }
      if (!result[id]) throw failure(copy('error'));
    }
    return result;
  }

  async function render(cart) {
    const ids = ['cart-drawer', 'cart-icon-bubble'];
    const mainItems = document.getElementById('main-cart-items');
    const mainFooter = document.getElementById('main-cart-footer');
    const itemsSection = mainItems?.dataset.id;
    const footerSection = mainFooter?.dataset.id;
    if (itemsSection) ids.push(itemsSection);
    if (footerSection) ids.push(footerSection);
    const html = await sections(ids);
    const parser = new DOMParser();
    const replace = (id, selector, sourceSelector = selector) => {
      if (!html[id]) return;
      const next = parser.parseFromString(html[id], 'text/html').querySelector(sourceSelector);
      const current = document.querySelector(selector);
      if (next && current) current.innerHTML = next.innerHTML;
    };
    const drawer = document.querySelector('cart-drawer');
    if (drawer?.classList.contains('active') && typeof drawer.renderContents === 'function') drawer.renderContents({ ...cart, sections: html });
    else {
      replace('cart-drawer', '#CartDrawer');
      document.getElementById('CartDrawer-Overlay')?.addEventListener('click', () => drawer?.close());
    }
    replace('cart-icon-bubble', '#cart-icon-bubble', '.shopify-section');
    if (itemsSection) replace(itemsSection, '#main-cart-items .js-contents', '.js-contents');
    if (footerSection) replace(footerSection, '#main-cart-footer .js-contents', '.js-contents');
    drawer?.classList.toggle('is-empty', cart.item_count === 0);
    document.querySelector('cart-items')?.classList.toggle('is-empty', cart.item_count === 0);
    mainFooter?.classList.toggle('is-empty', cart.item_count === 0);
    viewDirty = false;
    announce(state.error);
  }

  function enqueue(work) {
    const task = queue.then(async () => {
      state.busy = true;
      state.blocked = false;
      state.error = '';
      announce(copy('checking'));
      try {
        const result = await work();
        return result;
      } catch (error) {
        state.blocked = true;
        state.error = error.halloweenGift ? error.message : copy('error');
        throw error;
      } finally {
        state.busy = false;
        if (viewDirty) { state.blocked = true; state.error = state.error || copy('error'); }
        announce(state.error);
        scheduleExpiry();
      }
    });
    queue = task.catch(() => {});
    return task;
  }

  function reconcile(options = {}) {
    if (inert) return Promise.resolve({ cart: null, changed: false, inert: true });
    return enqueue(async () => {
      try {
        const result = await check();
        if (options.render && (result.changed || viewDirty)) await render(result.cart);
        return result;
      } catch (error) {
        if (options.render && error.changed && error.cart) await render(error.cart);
        throw error;
      }
    });
  }

  function scheduleExpiry() {
    clearTimeout(expiryTimer);
    if (inert) return;
    const next = now() < publicEnd ? publicEnd : expiry();
    const delay = next - now();
    if (delay > 0 && delay < 2147483647) expiryTimer = setTimeout(() => reconcile({ render: true }).catch(() => {}), delay + 100);
  }

  function cartMutation(input, init) {
    try {
      const url = new URL(typeof input === 'string' || input instanceof URL ? input : input.url, window.location.href);
      const method = String(init?.method || input?.method || 'GET').toUpperCase();
      return url.origin === window.location.origin && method !== 'GET' && /\/cart\/(add|change|update|clear)(\.js)?$/.test(url.pathname) ? url.pathname : '';
    } catch { return ''; }
  }

  function interceptedFetch(input, init) {
    if (inert) return nativeFetch(input, init);
    const mutation = cartMutation(input, init);
    if (!mutation) return nativeFetch(input, init);
    return enqueue(async () => {
      const response = await nativeFetch(input, init);
      if (!response.ok) return response;
      if (inert) return response;
      let original;
      try { original = await response.clone().json(); } catch { return response; }
      if (original.status) return response;
      let result;
      try { result = await check(); }
      catch (error) {
        state.blocked = true;
        state.error = error.halloweenGift ? error.message : copy('error');
        const safeCart = await read();
        if (gifts(safeCart).some(item => Number(item.final_line_price) !== 0)) throw error;
        result = { cart: safeCart, changed: true };
        result.error = state.error;
      }
      const ids = original.sections ? Object.keys(original.sections) : [];
      const refreshed = ids.length ? await sections(ids) : null;
      const updated = /\/add(?:\.js)?$/.test(mutation) ? { ...original } : { ...result.cart };
      if (refreshed) { updated.sections = refreshed; viewDirty = false; }
      if (result.error) {
        updated._td_halloween_error = result.error;
      }
      const headers = new Headers(response.headers);
      headers.delete('content-length');
      headers.delete('content-encoding');
      return new Response(JSON.stringify(updated), { status: response.status, statusText: response.statusText, headers });
    });
  }
  window.fetch = interceptedFetch;

  const checkoutTarget = target => target?.closest?.('[name="checkout"],a[href*="/checkout"],#CartDrawer-Checkout,#checkout');
  document.addEventListener('click', event => {
    if (inert) return;
    const target = checkoutTarget(event.target);
    if (!target || bypass.has(target)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    reconcile({ render: true }).then(() => {
      const destination = target.isConnected ? target : document.querySelector('#CartDrawer-Checkout') || document.querySelector('[name="checkout"]');
      if (!destination) return;
      bypass.add(destination);
      destination.click();
      bypass.delete(destination);
    }).catch(() => {});
  }, true);
  document.addEventListener('submit', event => {
    if (inert) return;
    const form = event.target;
    if (bypass.has(form) || bypass.has(event.submitter) || !event.submitter?.matches('[name="checkout"]')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    reconcile({ render: true }).then(() => {
      bypass.add(form);
      form.requestSubmit(event.submitter);
      bypass.delete(form);
    }).catch(() => {});
  }, true);
  document.addEventListener('click', event => {
    if (inert) return;
    if (event.target?.closest?.('[data-td-halloween-retry]')) reconcile({ render: true }).catch(() => {});
  });
  document.addEventListener('visibilitychange', () => {
    if (inert) return;
    if (document.visibilityState === 'visible') reconcile({ render: true }).catch(() => {});
  });
  window.addEventListener('pageshow', event => {
    if (inert) return;
    if (event.persisted) reconcile({ render: true }).catch(() => {});
  });
  window.addEventListener('storage', event => {
    if (inert) return;
    if (event.key === storageKey) { rememberEmail(); reconcile({ render: true }).catch(() => {}); }
  });
  if (typeof MutationObserver === 'function') {
    renderObserver = new MutationObserver(() => announce(state.busy ? copy('checking') : state.error));
    document.querySelectorAll('cart-drawer,#main-cart-items,#main-cart-footer').forEach(element => renderObserver.observe(element, { childList: true, subtree: true }));
  }
  rememberEmail();
  window.TDHalloweenGift = Object.freeze({ reconcile, getState: () => ({ ...state, emailAccess, expiresAt: expiry(), inert }) });
  reconcile({ render: true }).catch(() => {});
})();
